import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { PrivateRoute, TokenComponent } from "shared/components";
import Dashboard from "modules/dashboard";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="erl" element={<PrivateRoute element={<Dashboard />} />} />
        <Route path="/token" element={<TokenComponent />} />
        <Route path="/" element={<Navigate to="/erl" replace />} />
      </Routes>
    </Router>
  );
}
